import axios from "axios";
import { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import DataTable from "react-data-table-component";
import AshramCard from "./AshramCard";
import translatedHeading from "../utils/util";
import "../styles/App.css";


const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [copyBranches, setCopyBranches] = useState([]);
  useEffect(() => {
    axios
      .get("https://brahmavidyalayaashram.in/server/api.php?endpoint=/branches")
      .then(function (response) {
        console.log(response);
        if (response && response.data && Array.isArray(response.data)) {
          setBranches(response.data);
          setCopyBranches(response.data);
        }
      })
      .catch(function (error) {
        console.log("Some error happened", error);
      });
  }, []);

  const columns = [
    {
      name: "Place",
      selector: (row) => row.place,
      sortable: true,
      width: "8rem",
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => (
        <a href={row.map_link} target="_blank" rel="noreferrer">
          View on map
        </a>
      ),
      sortable: true,
      maxWidth: "10rem",
    },
  ];
  const handleSubmit = (value) => {
    handleChange(value);
    document.getElementById("search-ashram-input").blur();
  }
  const handleChange = (value) => {
    let searchValue = value.toLowerCase();
    if (!searchValue.trim()) {
      setBranches(copyBranches);
    }
    const currentBranchesList = [...copyBranches];
    const filteredBranches = currentBranchesList.filter((branch) => {
      return (
        branch.place.toLowerCase().includes(searchValue) ||
        branch.address.toLowerCase().includes(searchValue)
      );
    });
    setBranches(filteredBranches);
  };
  return (
    <div className="branches-page">
      <Header />
      <div className="page-header">{translatedHeading("Branches")}</div>
      <div className="main-branch-text">
        <div>
          <b>{translatedHeading("Main branch")}:</b> {translatedHeading("Brahm Vidyalaya and Ashram, Chottka Rajpur, Buxar, Bihar.")}
        </div>
        <div className="search-ashram">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e.target[0].value);
            }}
          >
            <input
              type="text"
              placeholder={translatedHeading("Search for a branch...")}
              className="search-ashram-input"
              id="search-ashram-input"
              onChange={(e) => handleChange(e.target.value)}
            />
          </form>
        </div>
      </div>
      <div className="branches">
        <div className="branches-table-view">
          <DataTable
            className="data-tables"
            columns={columns}
            data={branches}
            pagination
            striped
          />
        </div>
      </div>
      <div className="branches-mobile-view">
        {branches &&
          branches.map((branch) => (
            <AshramCard key={branch.place} branch={branch} />
          ))}
      </div>
      <Footer />
    </div>
  );
};
export default Branches;
